import {ButtonIcon} from '@homeaway/react-buttons';
import {compose} from 'redux';
import React, {Component} from 'react';
import {COLLABORATE__24} from '../../../components/svg-def';
import edap from '../edap';
import {SHARE__16} from '@homeaway/svg-defs'
import {withCollaborateState} from './state';
import {withTranslationsAsProps} from '../../../components/translations';

export const CollaborateIcon = {
    INVITE: COLLABORATE__24,
    SHARE: SHARE__16
}

export const CollaborateType = {
    INVITE: 'invite',
    SHARE: 'share'
}

export class CollaborateButton extends Component {
    static defaultProps = {
        boardId: null,
        collaborate: () => {},
        reset: () => {},
        label: '',
        type: '' // CollaborateType
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.reset();
    }

    shouldComponentUpdate() {
        return false;
    }

    componentWillUnmount() {
        this.props.reset();
    }

    onClick = () => {
        const {boardId, collaborate, endDate, startDate} = this.props;
        collaborate();
        edap.buttonClick(boardId, endDate, startDate);
    }

    render() {
        const {label, type} = this.props;
        const svgMarkup = (type === CollaborateType.INVITE) ? CollaborateIcon.INVITE : CollaborateIcon.SHARE;
        return (
            <ButtonIcon
                circle
                className="btn-icon-responsive"
                label={label}
                onClick={this.onClick}
                svgMarkup={svgMarkup}
                size="sm"
            />
        );
    }
}

export default compose(
    withCollaborateState,
    withTranslationsAsProps({
        'tripboards.share.text': 'label'
    })
)(CollaborateButton);


// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/invite-share-button.js